import { defineMessages } from 'react-intl';

import { BillingProductBlockReason } from '@/entities/organization';

import { OrderStatus } from '../lib';

export const billingHistoryBlockReasonMessages =
  defineMessages<BillingProductBlockReason>({
    noPermission: {
      id: 'billingHistory.actionsNoPermissionTooltip',
      defaultMessage: 'You do not have permission to manage billing orders.',
    },
  });

export const billingHistoryMessages = defineMessages({
  customPriceAmount: {
    id: 'billingHistory.amount.customPrice',
    defaultMessage: '{amount} (list {listPrice})',
  },
  diagnocoinAdjustmentSubject: {
    id: 'billingHistory.subject.diagnocoinAdjustment',
    defaultMessage: 'Diagnocoin correction: −{amount}',
  },
});

export const orderStatusText = defineMessages<OrderStatus>({
  'paid': {
    id: 'orderStatus.paid',
    defaultMessage: 'Paid',
  },
  'processed': {
    id: 'orderStatus.processed',
    defaultMessage: 'Processed',
  },
  'deleted': {
    id: 'orderStatus.deleted',
    defaultMessage: 'Deleted',
  },
  'new': {
    id: 'orderStatus.new',
    defaultMessage: 'New',
  },
  'overdue': {
    id: 'orderStatus.overdue',
    defaultMessage: 'Overdue',
  },
});
